import { CurrentUserContext, useCurrentUserContext } from "@stadium/hooks/lib/use-current-user";
import CurrentUserProvider from "@stadium/hooks/lib/use-current-user/current-user-provider";

export { useCurrentUserContext, CurrentUserContext };
export default CurrentUserProvider;
